export default __webpack_public_path__ + "static/media/linehaul_white.6dd428d4.svg";